import { render, staticRenderFns } from "./VProjectActionTaskForm.vue?vue&type=template&id=089592cc&"
import script from "./VProjectActionTaskForm.vue?vue&type=script&lang=js&"
export * from "./VProjectActionTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports